import { Image, StyleSheet, View } from '@react-pdf/renderer'
import React from 'react'

interface PdfHeatmapWithLegendProps {
  heatmapSrc: string
  legendSrc?: string
  heatmapHeight?: number
  legendHeight?: number
  legendWidth?: number
  maxWidth?: number
  gap?: number
  reserveLegendSpace?: boolean
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    width: '100%',
    alignItems: 'flex-start',
  },
  centerColumn: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  heatmapImage: {
    width: '100%',
    objectFit: 'contain',
    flexGrow: 0,
    flexShrink: 1,
    alignSelf: 'center',
  },
  legendImage: {
    objectFit: 'contain',
  },
})

export const PdfHeatmapWithLegend: React.FC<PdfHeatmapWithLegendProps> = ({
  heatmapSrc,
  legendSrc,
  heatmapHeight = 330,
  legendHeight = heatmapHeight,
  legendWidth = 64,
  maxWidth,
  gap = 16,
  reserveLegendSpace = true,
}) => {
  const sideColumnWidth = legendSrc ? legendWidth + gap : 0

  return (
    <View style={styles.row}>
      {legendSrc && reserveLegendSpace ? (
        <View style={{ width: sideColumnWidth }} />
      ) : null}
      <View style={styles.centerColumn}>
        <Image
          src={heatmapSrc}
          cache={false}
          style={[
            styles.heatmapImage,
            { height: heatmapHeight },
            maxWidth ? { maxWidth } : {},
          ]}
        />
      </View>
      {legendSrc ? (
        <View style={{ width: legendWidth, marginLeft: gap }}>
          <Image
            src={legendSrc}
            cache={false}
            style={[
              styles.legendImage,
              { width: legendWidth, height: legendHeight },
            ]}
          />
        </View>
      ) : null}
    </View>
  )
}
